import React from 'react';
import { Title } from 'rizzui';
import cn from '../../utils/classNames';
import Breadcrumb from './breadcrumb';

export type PageHeaderTypes = {
    title: any;
    breadcrumb?: { name: string; href?: string }[];
    className?: string;
    isSticky?: boolean;
    headerFilters?: React.ReactNode;
};

export default function PageHeader({ title, breadcrumb, children, className, isSticky = true, headerFilters }: React.PropsWithChildren<PageHeaderTypes>) {
    return (
        <header className={cn('py-2 mb-6 @container top-[80px] lg:mb-7 bg-[#f0f0f5] z-[70] ', className, isSticky ? 'sticky ' : '')}>
            <div className="flex flex-col @lg:flex-row @lg:items-center @lg:justify-between">
                <div>
                    <Title
                        as="h2"
                        className="mb-2 text-[22px] lg:text-2xl 4xl:text-[26px]"
                    >
                        {title}
                    </Title>

                    <Breadcrumb separator="" separatorVariant="circle" className={cn("flex-wrap", { "hidden": !breadcrumb })}>
                        {breadcrumb?.map((item) => (
                            <Breadcrumb.Item
                                key={item.name}
                                {...(item?.href && { href: item?.href })}
                            >
                                {item.name}
                            </Breadcrumb.Item>
                        ))}
                    </Breadcrumb>

                </div>

                {headerFilters}

                {children}
            </div>
        </header>
    );
}